import _classCallCheck from "/workdir/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _assertThisInitialized from "/workdir/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/workdir/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/workdir/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/workdir/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _wrapNativeSuper from "/workdir/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { loc } from '../../packages/@okta/courage-dist/esm/src/CourageForSigninWidget.js';
import '../../packages/@okta/courage-dist/esm/src/courage/framework/Model.js';
import '../../packages/@okta/courage-dist/esm/src/courage/vendor/lib/backbone.js';
import '../../packages/@okta/courage-dist/esm/src/courage/util/jquery-wrapper.js';
import '../../packages/@okta/courage-dist/esm/src/courage/util/underscore-wrapper.js';
import '../../packages/@okta/courage-dist/esm/lib/handlebars/dist/cjs/handlebars.runtime.js';
import '../../packages/@okta/courage-dist/esm/src/courage/models/Model.js';
import '../../packages/@okta/courage-dist/esm/src/courage/models/BaseModel.js';
import '../../packages/@okta/courage-dist/esm/src/courage/framework/View.js';
import '../../packages/@okta/courage-dist/esm/src/courage/views/Backbone.ListView.js';
import Enums from './Enums.js';
/*!
 * Copyright (c) 2015-2016, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

var CustomError = /*#__PURE__*/function (_Error) {
  _inherits(CustomError, _Error);

  var _super = _createSuper(CustomError);

  function CustomError(message) {
    var _this;

    _classCallCheck(this, CustomError);

    _this = _super.call(this, message); // 'Error' breaks prototype chain. Need to restore it for ES5.
    // https://github.com/microsoft/TypeScript/wiki/FAQ#why-doesnt-extending-built-ins-like-error-array-and-map-work
    // Note: no need to adjust prototype in subclasses of 'CustomError'.

    Object.setPrototypeOf(_assertThisInitialized(_this), (this instanceof CustomError ? this.constructor : void 0).prototype);
    return _this;
  }

  return CustomError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var ConfigError = /*#__PURE__*/function (_CustomError) {
  _inherits(ConfigError, _CustomError);

  var _super2 = _createSuper(ConfigError);

  function ConfigError(message) {
    var _this2;

    _classCallCheck(this, ConfigError);

    _this2 = _super2.call(this, message || loc('error.config'));
    _this2.name = Enums.CONFIG_ERROR;
    return _this2;
  }

  return ConfigError;
}(CustomError);

var UnsupportedBrowserError = /*#__PURE__*/function (_CustomError2) {
  _inherits(UnsupportedBrowserError, _CustomError2);

  var _super3 = _createSuper(UnsupportedBrowserError);

  function UnsupportedBrowserError(message) {
    var _this3;

    _classCallCheck(this, UnsupportedBrowserError);

    _this3 = _super3.call(this, message || loc('error.unsupported.browser'));
    _this3.name = Enums.UNSUPPORTED_BROWSER_ERROR;
    return _this3;
  }

  return UnsupportedBrowserError;
}(CustomError);

var OAuthError = /*#__PURE__*/function (_CustomError3) {
  _inherits(OAuthError, _CustomError3);

  var _super4 = _createSuper(OAuthError);

  function OAuthError() {
    var _this4;

    _classCallCheck(this, OAuthError);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this4 = _super4.call.apply(_super4, [this].concat(args));
    _this4.name = Enums.OAUTH_ERROR;
    return _this4;
  }

  return OAuthError;
}(CustomError);

var RegistrationError = /*#__PURE__*/function (_CustomError4) {
  _inherits(RegistrationError, _CustomError4);

  var _super5 = _createSuper(RegistrationError);

  function RegistrationError() {
    var _this5;

    _classCallCheck(this, RegistrationError);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this5 = _super5.call.apply(_super5, [this].concat(args));
    _this5.name = Enums.REGISTRATION_FAILED;
    return _this5;
  }

  return RegistrationError;
}(CustomError); // Thrown when initiation of poll was cancelled.


var AuthStopPollInitiationError = /*#__PURE__*/function (_CustomError5) {
  _inherits(AuthStopPollInitiationError, _CustomError5);

  var _super6 = _createSuper(AuthStopPollInitiationError);

  function AuthStopPollInitiationError() {
    var _this6;

    _classCallCheck(this, AuthStopPollInitiationError);

    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _this6 = _super6.call.apply(_super6, [this].concat(args));
    _this6.name = Enums.AUTH_STOP_POLL_INITIATION_ERROR;
    return _this6;
  }

  return AuthStopPollInitiationError;
}(CustomError);

var U2FError = /*#__PURE__*/function (_CustomError6) {
  _inherits(U2FError, _CustomError6);

  var _super7 = _createSuper(U2FError);

  function U2FError(err) {
    var _this7;

    _classCallCheck(this, U2FError);

    var _err$xhr, _err$xhr$responseJSON;

    _this7 = _super7.call(this, (_err$xhr = err.xhr) === null || _err$xhr === void 0 ? void 0 : (_err$xhr$responseJSON = _err$xhr.responseJSON) === null || _err$xhr$responseJSON === void 0 ? void 0 : _err$xhr$responseJSON.errorSummary);
    _this7.xhr = void 0;
    _this7.name = Enums.U2F_ERROR;
    _this7.xhr = err.xhr;
    return _this7;
  }

  return U2FError;
}(CustomError);

var WebAuthnError = /*#__PURE__*/function (_CustomError7) {
  _inherits(WebAuthnError, _CustomError7);

  var _super8 = _createSuper(WebAuthnError);

  function WebAuthnError(err) {
    var _this8;

    _classCallCheck(this, WebAuthnError);

    var _err$xhr2, _err$xhr2$responseJSO;

    _this8 = _super8.call(this, (_err$xhr2 = err.xhr) === null || _err$xhr2 === void 0 ? void 0 : (_err$xhr2$responseJSO = _err$xhr2.responseJSON) === null || _err$xhr2$responseJSO === void 0 ? void 0 : _err$xhr2$responseJSO.errorSummary);
    _this8.xhr = void 0;
    _this8.name = Enums.WEB_AUTHN_ERROR;
    _this8.xhr = err.xhr;
    return _this8;
  }

  return WebAuthnError;
}(CustomError); // This is triggered only when code aborts webauthn browser prompt.


var WebauthnAbortError = /*#__PURE__*/function (_CustomError8) {
  _inherits(WebauthnAbortError, _CustomError8);

  var _super9 = _createSuper(WebauthnAbortError);

  function WebauthnAbortError() {
    var _this9;

    _classCallCheck(this, WebauthnAbortError);

    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _this9 = _super9.call.apply(_super9, [this].concat(args));
    _this9.name = Enums.WEBAUTHN_ABORT_ERROR;
    return _this9;
  }

  return WebauthnAbortError;
}(CustomError);

var ConfiguredFlowError = /*#__PURE__*/function (_CustomError9) {
  _inherits(ConfiguredFlowError, _CustomError9);

  var _super10 = _createSuper(ConfiguredFlowError);

  function ConfiguredFlowError(message, flowSetting) {
    var _this10;

    _classCallCheck(this, ConfiguredFlowError);

    _this10 = _super10.call(this, message);
    _this10.flowSetting = void 0;
    _this10.name = Enums.CONFIGURED_FLOW_ERROR;
    _this10.flowSetting = flowSetting;
    return _this10;
  }

  return ConfiguredFlowError;
}(CustomError);

export { AuthStopPollInitiationError, ConfigError, ConfiguredFlowError, OAuthError, RegistrationError, U2FError, UnsupportedBrowserError, WebAuthnError, WebauthnAbortError };